(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/arena-react/assets/react/pages/teams/components/info-pair-amount.js') >= 0) return;  svs.modules.push('/modules/arena-react/assets/react/pages/teams/components/info-pair-amount.js');
'use strict';

const InfoPairAmount = _ref => {
  let title = _ref.title,
    amount = _ref.amount,
    _ref$isBold = _ref.isBold,
    isBold = _ref$isBold === void 0 ? false : _ref$isBold,
    _ref$isColor = _ref.isColor,
    isColor = _ref$isColor === void 0 ? false : _ref$isColor;
  let style = '';
  if (isColor) {
    style = parseInt(amount, 10) > 0 ? 'fc-green' : 'fc-red';
  }
  if (isBold) {
    style += ' f-bold';
  }
  return React.createElement("span", null, title, ': ', React.createElement("span", {
    className: style
  }, svs.utils.format.Currency(amount), ' kr'));
};
svs.arena.pages.teams.components.InfoPairAmount = InfoPairAmount;

 })(window);